"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const UserIcon = (props) => {
    return (react_1.default.createElement("svg", { className: props.size, viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("path", { className: props.color, fillRule: "evenodd", clipRule: "evenodd", d: "M22 12.0001C22 17.5229 17.5228 22.0001 12 22.0001C6.47715 22.0001 2 17.5229 2 12.0001C2 6.47721 6.47715 2.00006 12 2.00006C17.5228 2.00006 22 6.47721 22 12.0001ZM15 10.0001C15 11.657 13.6569 13.0001 12 13.0001C10.3431 13.0001 9 11.657 9 10.0001C9 8.34326 10.3431 7.00012 12 7.00012C13.6569 7.00012 15 8.34326 15 10.0001ZM12 21C15.3137 21 18 19.433 18 17.5C18 15.5671 15.3137 14.0001 12 14.0001C8.68628 14.0001 5.99999 15.5671 5.99999 17.5C5.99999 19.433 8.68628 21 12 21Z" })));
};
exports.default = UserIcon;
